import { CheckCircle } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

const ServiceBenefits = ({ benefits }) => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    // Process the benefits to remove emoji and keep clean text
    const cleanBenefits = benefits.map(benefit => benefit.replace(/^✅ /, ''));

    return (
        <section
            id="benefits"
            ref={sectionRef}
            className={`py-16 bg-teal-50 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
            <div className="px-4 md:px-20">
                <h2 className="text-3xl font-bold mb-2 text-teal-600">Why Choose This Treatment?</h2>
                <div className="w-24 h-1 bg-lime-500 mb-12 mt-2"></div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                    {cleanBenefits.map((benefit, index) => (
                        <div
                            key={index}
                            className={`bg-white rounded-xl shadow-md p-6 border-t-4 border-teal-500 transform transition-all duration-500 hover:shadow-lg hover:-translate-y-1 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
                            style={{ transitionDelay: `${index * 100}ms` }}
                        >
                            <div className="flex items-start">
                                <CheckCircle className="text-lime-500 h-6 w-6 mr-3 flex-shrink-0 mt-1" />
                                <p className="text-lg text-gray-700">{benefit}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ServiceBenefits;